import React from 'react';
import classNames from 'classnames';
import pt from 'prop-types';

import Link from 'components/link';

import './button.scss';

function ButtonLink({
  size = 'md',
  type = 'default',
  className,
  disabled,
  children,
  ...props
}) {
  const classes = classNames(
    `button button-${size} button-${type}`,
    className,
    {
      'button-disabled': Boolean(disabled),
    },
  );

  if (!disabled) {
    if (props.to) {
      return (
        <Link className={classes} {...props}>
          {children}
        </Link>
      );
    }

    if (props.href) {
      return (
        <Link className={classes} target="_blank" {...props} to={props.href}>
          {children}
        </Link>
      );
    }
  }

  return (
    <button
      disabled={disabled}
      className={classes}
      {...props}
      onClick={!disabled ? props.onClick : undefined}
      type="button"
    >
      {children}
    </button>
  );
}

ButtonLink.propTypes = {
  to: pt.string,
  href: pt.string,
  size: pt.string,
  type: pt.string,
  className: pt.string,
  disabled: pt.bool,
  children: pt.node,
  onClick: pt.func,
};

export default React.memo(ButtonLink);
